import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useEffect, useState } from "react";
import {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} from "slices/beautyApp/categorySlice";
import { Button } from "@mui/material";
import AddForm from "./addForm";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Categories() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [add] = useAddCategoryMutation();
  const [update] = useUpdateCategoryMutation();
  const [del] = useDeleteCategoryMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetCategoriesQuery({
    page,
    limit,
    search,
  });
  const col = [
    { display: "Name", key: "name", type: "display" },
    {
      display: "Image",
      key: "image",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
    {
      display: "Background-Image",
      key: "backgroundImage",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
    // {
    //   display: "Actions",
    //   key: "edit",
    //   type: "action",

    //   render: (row, onEdit, handleDelete) => {
    //     const canEdit = hasActionAccess(
    //       auth,
    //       "Beauty App",
    //       "Categories",
    //       "edit"
    //     );
    //     const canDelete = hasActionAccess(
    //       auth,
    //       "Beauty App",
    //       "Categories",
    //       "delete"
    //     );

    //     return (
    //       <>
    //         {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
    //         {canDelete && (
    //           <Button onClick={() => handleDelete(row._id)}>Delete</Button>
    //         )}
    //       </>
    //     );
    //   },
    // },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Categories", "edit");
  const canDelete = hasActionAccess(auth, "Beauty App", "Categories", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    try {
      let formData = new FormData();
      formData.append("name", data.name);
      formData.append("metaTitle", data.metaTitle);
      formData.append("metaDescription", data.metaDescription);
      formData.append("package", data.package);
      formData.append("module_type", data.module_type);
      formData.append("linked_url", data.linked_url);
      formData.append("description", data.description);

      // Only append image if it is a File (i.e., user selected a new one)
      if (data.image instanceof File) {
        formData.append("image", data.image);
      }
      // Only append image if it is a File (i.e., user selected a new one)
      if (data.appIcon instanceof File) {
        formData.append("appIcon", data.appIcon);
      }
      if (data.appBackgroundImage instanceof File) {
        formData.append("appBackgroundImage", data.appBackgroundImage);
      }

      if (data.backgroundImage instanceof File) {
        formData.append("backgroundImage", data.backgroundImage);
      }

      if (data.keywords.length > 0) {
        for (let index = 0; index < data.keywords.length; index++) {
          formData.append("keywords", data.keywords[index]);
        }
      }

      if (editing) {
        await update({ id: data._id, body: formData }).unwrap();
        refetch();
      } else {
        await add(formData).unwrap();
        refetch();
      }

      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null); // <-- Clear editing data
  };

  const canAdd = hasActionAccess(auth, "Beauty App", "Categories", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddForm
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />
      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Category
        </Button>
      )}

      <Tables
        title={"Categories"}
        handleSearch={handleSearchChange}
        totalPages={data?.pagination?.totalPages}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Categories;
